<template>
  <div class="news-wrap">
    <ul class="news-list">
      <li 
        v-for="(item, index) in noticeList" 
        :key="item.id || index"
        class="news-item" 
        @click="$parent.goNav(`/myNewsInfo?id=${item.id}`)"
      >
        <div class="news-card">
          <!-- 缩略图区域 - 优化显示清晰度 -->
          <div class="news-thumbnail" :class="getTypeClass(item.type)">
            <img 
              :src="getHighResImage(item)" 
              :alt="item.title"
              class="thumbnail-img"
              loading="lazy"
              @error="handleImageError(item, $event)"
            >
          </div>
          
          <div class="news-content-wrapper">
            <div class="news-header">
              <div class="title-container">
                <span class="news-type" :class="getTypeClass(item.type)">
                  {{ getTypeName(item.type) }}
                </span>
                <span class="news-title">{{ item.title }}</span>
              </div>
              <span class="news-time">{{ item.created_at }}</span>
            </div>
            
            <!-- 内容区域 -->
            <div class="news-content" v-html="removeImagesFromContent(item.content)"></div>
          </div>
        </div>
      </li>
    </ul>

    <!-- 状态提示 -->
    <div v-if="isLoading" class="loading-state">
      <div class="loading-icon"></div>
      <p>加载中...</p>
    </div>
    
    <div v-if="!isLoading && noticeList.length === 0" class="empty-state">
      <div class="empty-icon"></div>
      <p>暂无消息</p>
      <button @click="retryLoad" class="retry-btn">重试加载</button>
    </div>

    <!-- 分页组件 -->
    <div class="pagination-wrap" v-if="!isLoading && total > pageSize">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myNews',
  data() {
    return { 
      noticeList: [], 
      page: 1,
      pageSize: 6, // 每页显示5条
      total: 0,
      isLoading: false,
      loadError: false
    };
  },
  created() {
    this.getnoticeList();
  },
  methods: {
    getnoticeList() {
      this.loadError = false;
      this.isLoading = true;
      
      // 请求参数，不包含类型筛选
      const params = { 
        page: this.page, 
        limit: this.pageSize
      };
      
      this.$apiFun
        .post('/api/noticeList', params)
        .then(res => {
          
          if (!res) {
            throw new Error('接口返回为空');
          }
          
          if (res.code !== 200) {
            this.$parent.showTost(0, res.message || '获取数据失败');
            this.loadError = true;
            return;
          }
          
          if (!res.data) {
            throw new Error('返回数据结构不正确，缺少data字段');
          }
          
          this.noticeList = Array.isArray(res.data.data) ? res.data.data : [];
          this.total = Number(res.data.total) || 0;
        })
        .catch(error => {
          console.error('加载数据出错:', error);
          this.$parent.showTost(0, '加载失败，请稍后重试');
          this.noticeList = [];
          this.total = 0;
          this.loadError = true;
        })
        .finally(() => {
          this.isLoading = false;
          this.$parent.hideLoading();
        });
    },
    handlePageChange(newPage) {
      this.page = newPage;
      this.getnoticeList();
    },
    retryLoad() {
      this.getnoticeList();
    },
    // 获取高清图片地址 - 优化清晰度
    getHighResImage(item) {
      // 优先使用内容中的高清图
      const contentImg = this.extractFirstImage(item.content);
      if (contentImg) {
        // 优化图片URL，获取最高清版本
        return this.optimizeImageUrl(contentImg);
      }
      
      // 其次使用缩略图
      if (item.thumbnail) {
        return this.optimizeImageUrl(item.thumbnail);
      }
      
      // 最后使用默认图
      return this.getDefaultThumbnail(item.type);
    },
    // 优化图片URL，获取更高分辨率
    optimizeImageUrl(url) {
      if (!url) return '';
      
      // 处理常见的图片尺寸参数，获取最大可能的分辨率
      if (url.includes('?w=') && url.includes('&h=')) {
        // 移除尺寸限制或设置为较大值
        return url.replace(/w=\d+/, 'w=800').replace(/h=\d+/, 'h=600');
      }
      
      // 处理其他图片服务的尺寸参数
      if (url.includes('?width=') && url.includes('&height=')) {
        return url.replace(/width=\d+/, 'width=800').replace(/height=\d+/, 'height=600');
      }
      
      // 处理仅含宽度或高度参数的情况
      if (url.includes('?w=')) {
        return url.replace(/w=\d+/, 'w=800');
      }
      
      if (url.includes('?width=')) {
        return url.replace(/width=\d+/, 'width=800');
      }
      
      // 对于没有尺寸参数的图片，直接返回
      return url;
    },
    // 处理图片加载失败的情况
    handleImageError(item, event) {
      event.target.src = this.getDefaultThumbnail(item.type);
    },
    getTypeName(type) {
      const typeStr = String(type);
      switch(typeStr) {
        case '1': return '通知';
        case '2': return '活动';
        case '3': return '公告';
        default: return '消息';
      }
    },
    getTypeClass(type) {
      const typeStr = String(type);
      switch(typeStr) {
        case '1': return 'type-notice';
        case '2': return 'type-activity';
        case '3': return 'type-announcement';
        default: return '';
      }
    },
    getDefaultThumbnail(type) {
      const typeStr = String(type);
      switch(typeStr) {
        case '1': // 通知 - 蓝色信封（优化版）
          return '/static/style/tongzhi.svg';
          
        case '2': // 活动 - 绿色日历（优化版）
          return '/static/style/huodong.svg';

        case '3': // 公告 - 橙色公告板（优化版）
          return '/static/style/gonggao.svg';
      }
    },
    extractFirstImage(content) {
      if (!content) return null;
      const imgRegex = /<img[^>]+src=("|')([^"'>]+)\1/gi;
      const match = imgRegex.exec(content);
      return match && match[2] ? match[2] : null;
    },
    removeImagesFromContent(content) {
      if (!content) return '';
      return content.replace(/<img[^>]*>/gi, '');
    }
  },
};
</script>

<style lang="scss" scoped>
.news-wrap {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
  min-height: 100vh;
  box-sizing: border-box;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  
}

.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.news-item {
  cursor: pointer;
}

.news-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  padding: 15px;
  transition: all 0.3s;
  display: flex;
  gap: 15px;
  align-items: flex-start;
  
  &:hover {
    box-shadow: 0 4px 15px rgba(0,0,0,0.08);
    transform: translateY(-2px);
  }
}

// 缩略图样式优化 - 提升清晰度
.news-thumbnail {
  width: 100px;  // 适当增大尺寸
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  background-color: #f5f7fa;
  
  // 添加轻微的内阴影增强视觉效果
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1);
  
  &.type-notice {
    box-shadow: 0 0 0 2px #409eff inset, inset 0 0 3px rgba(0,0,0,0.1);
  }
  
  &.type-activity {
    box-shadow: 0 0 0 2px #67c23a inset, inset 0 0 3px rgba(0,0,0,0.1);
  }
  
  &.type-announcement {
    box-shadow: 0 0 0 2px #e6a23c inset, inset 0 0 3px rgba(0,0,0,0.1);
  }
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例，裁剪多余部分 */
  image-rendering: -webkit-optimize-contrast; /* 优化图片显示质量 */
  image-rendering: pixelated; /* 对于小图片放大时保持清晰度 */
  transition: transform 0.3s ease;
  
  // 悬停时略微放大，增强交互感
  .news-card:hover & {
    transform: scale(1.03);
  }
}

// 内容区域样式
.news-content-wrapper {
  flex: 1;
  min-width: 0;
  padding: 5px 0;
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.title-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.news-type {
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 13px;
  color: white;
  font-weight: 500;
  
  &.type-notice {
    background-color: #409eff;
  }
  
  &.type-activity {
    background-color: indianred;
  }
  
  &.type-announcement {
    background-color: #e6a23c;
  }
}

.news-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-time {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  margin-left: 10px;
}

.news-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  p {
    margin: 5px 0;
  }
}

// 加载状态样式
.loading-state {
  text-align: center;
  padding: 60px 20px;
  color: #666;
  font-size: 16px;
}

.loading-icon {
  width: 40px;
  height: 40px;
  margin: 0 auto 15px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 16px;
  background-color: #fafafa;
  border-radius: 10px;
  margin-top: 20px;
}

.retry-btn {
  margin-top: 15px;
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #308eff;
  }
}

.empty-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  
  &::after {
    content: '📄';
    font-size: 24px;
  }
}

.pagination-wrap {
  margin-top: 30px;
  text-align: center;
}

// 响应式调整
@media (max-width: 768px) {
  .news-wrap {
    padding: 15px 10px;
  }
  
  .news-card {
    padding: 12px;
    gap: 12px;
  }
  
  .news-thumbnail {
    width: 80px;
    height: 80px;
  }
  
  .news-header {
    flex-direction: column;
    align-items: flex-start;
    
    .news-time {
      margin-left: 0;
      margin-top: 5px;
      font-size: 11px;
    }
  }
  
  .news-title {
    font-size: 15px;
  }
  
  .news-content {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/myNews.vue